var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99964 8.00002L12.9996 1.00002M6.08469 8.21873L7.83677 12.7241C7.99112 13.121 8.06829 13.3194 8.17949 13.3774C8.27589 13.4276 8.39073 13.4276 8.48719 13.3775C8.59846 13.3197 8.67586 13.1214 8.83068 12.7247L13.2242 1.46616C13.364 1.10804 13.4339 0.928975 13.3956 0.814557C13.3625 0.715191 13.2845 0.637212 13.1851 0.604017C13.0707 0.565793 12.8916 0.63567 12.5335 0.775424L1.27501 5.16898C0.878295 5.3238 0.679937 5.40121 0.622131 5.51248C0.572019 5.60894 0.572086 5.72377 0.622312 5.82017C0.680249 5.93137 0.878697 6.00855 1.27559 6.16289L5.78093 7.91497C5.8615 7.9463 5.90178 7.96197 5.9357 7.98616C5.96576 8.00761 5.99206 8.0339 6.0135 8.06396C6.0377 8.09789 6.05336 8.13817 6.08469 8.21873Z",
    stroke: "#0675FC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.912e1d275a8943b67168e0a880e2542a.svg";
export { ForwardRef as ReactComponent };